module.exports = __webpack_public_path__ + "togo-menu-logo.svg?654f84d5cc75eb7a91bd39e32d512bb5";


//////////////////
// WEBPACK FOOTER
// ./static/togo-menu-logo.svg
// module id = 567
// module chunks = 0